<script lang="ts">
  import { Button } from "@/lib/components/ui/button";
  import { cn } from "@/lib/utils";
  import { format } from "date-fns";

  export let activity;
  export let title: string;
  export let subtitle: string;
  export let isFlipped: boolean;
  export let isActive: boolean;
  
</script>

<div class={cn('w-full rounded-2xl p-[1px] transition-transform',
    isActive ? 'scale-[1.0]' : 'scale-[0.7]',
  )}
  style='background: linear-gradient(5deg, rgba(18,20,22,1) 60%, rgba(40,44,48,0.18) 85%, rgba(94,230,232,0.10) 100%); box-shadow: 0 8px 24px rgba(0,0,0,0.35), inset 0 0 8px rgba(255,255,255,0.04);'
>
  <div class='rounded-2xl bg-[radial-gradient(circle_at_80%_10%,rgba(255,255,255,0.06),transparent_40%),radial-gradient(circle_at_80%_90%,rgba(255,255,255,0.04),transparent_40%),linear-gradient(180deg,rgba(18,20,22,0.95),rgba(8,9,10,0.98))]'>
    <div class={cn('w-full flex flex-col items-center p-4 gap-3 text-off-white overflow-hidden')}>
      <div class={cn('w-full flex flex-col items-center justify-center gap-1 pt-1 start-hidden')} class:slide-in-top={isFlipped}>
        <span class='text-xl font-bold tracking-wide'>{title}</span>
      </div>
      <div class='w-full rounded-xl overflow-hidden border border-[#2f3336] bg-[#0b0c0d] start-hidden anim-delay-200' class:img-pop-in={isFlipped}>
        <img class='w-full h-[180px] object-cover' src={((activity?.has_map_image !== false && activity.map_url) ? activity.map_url : activity.chart_url)?.replace(/^.*(?=\/assets)/, '')} alt='Activity' />
      </div>
      <div class='w-full flex flex-col items-center gap-1 text-center px-2'>
        <span class='text-base font-medium start-hidden anim-delay-400' class:slide-in-right={isFlipped}>{format(new Date(activity.start_date), 'EEE, MMM d · hh:mm aa')}</span>
        <span class='text-base font-bold text-[#5ee6e8] start-hidden anim-delay-600' class:slide-in-left={isFlipped}>{activity.name}</span>
        <span class='text-lg font-medium tracking-wide mt-1 start-hidden anim-delay-1000' class:slide-in-bottom={isFlipped}>{subtitle}</span>
      </div>
      <div class='start-hidden anim-delay-1200' class:slide-in-bottom={isFlipped}>
        <Button variant='outline' class='bg-transparent border border-border mt-1 hover:bg-[#5ee6e8] hover:text-off-white' href={"/activities/" + activity.path} target='_blank' rel='noopener noreferrer'>
          View Activity
        </Button>
      </div>
    </div>
  </div>
</div>

<style>
  /* Title animates when layout shifts (position changes) */
  .animated-title {
    transition: transform 1200ms ease, height 1200ms ease;
  }

  /* Image expands from a dot in the center */
  .img-pop-in {
    transform-origin: center center;
    animation: img-pop-in-key 500ms ease-out both;
  }
  @keyframes img-pop-in-key {
    0% { transform: scale(0); opacity: 0; }
    60% { transform: scale(1.05); opacity: 1; }
    100% { transform: scale(1); opacity: 1; }
  }

  .start-hidden {
    opacity: 0;
  }

  /* Slide-ins clipped to card via overflow-hidden on parent */
  .slide-in-right { animation: slide-in-right-key 420ms ease-out both; }
  .slide-in-left  { animation: slide-in-left-key  420ms ease-out both; }
  .slide-in-bottom{ animation: slide-in-bottom-key 420ms ease-out both; }
  .slide-in-top{ animation: slide-in-top-key 420ms ease-out both; }
  /* Stagger helpers for animation-delay */
  .anim-delay-200 { animation-delay: 200ms; }
  .anim-delay-400 { animation-delay: 400ms; }
  .anim-delay-600 { animation-delay: 600ms; }
  .anim-delay-1000 { animation-delay: 1000ms; }
  .anim-delay-1200 { animation-delay: 1200ms; }
  @keyframes slide-in-right-key {
    0% { transform: translateX(24px); opacity: 0; }
    100%{ transform: translateX(0);    opacity: 1; }
  }
  @keyframes slide-in-left-key {
    0% { transform: translateX(-24px); opacity: 0; }
    100%{ transform: translateX(0);     opacity: 1; }
  }
  @keyframes slide-in-bottom-key {
    0% { transform: translateY(24px); opacity: 0; }
    100%{ transform: translateY(0);    opacity: 1; }
  }
  @keyframes slide-in-top-key {
    0% { transform: translateY(-24px); opacity: 0; }
    100%{ transform: translateY(0);    opacity: 1; }
  }
</style>